import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export class Auth0OrganizationInvitationError extends CodedError {
  static get errorName() {
    return errorCodes.auth0OrganizationInvitationError.code;
  }

  constructor(message: string = errorCodes.auth0OrganizationInvitationError.message) {
    super(message);
    this.code = errorCodes.auth0OrganizationInvitationError.code;
    this.message = `${message} ${errorCodes.auth0OrganizationInvitationError.code}`;
    this.name = errorCodes.auth0OrganizationInvitationError.name;
    this.status = errorCodes.auth0OrganizationInvitationError.status;
  }
}
